import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';
import { round } from 'mathjs';

function valueLabelFormat(value) {
    if (value > 100) {
        return (round(value, 0));
    }
    if (value > 10) {
        return (round(value, 1));
    }
    else {
        return (round(value, 2));
    }
}

const useStyles = makeStyles((theme) => ({
    root: {
        height: '200px',
        marginTop: '10px',
        padding: '10px',
        //background: 'red',
    },
    margin: {

    },
}));

const sliderBoxShadow =
    '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';


const VerticalSlider = withStyles((theme) => ({
    root: {
        color: '#151515',
        padding: '0px 0px',
        fontFamily: "'Montserrat', sans-serif",
    },

    thumb: {
        height: 22,
        width: 22,
        backgroundColor: 'whitesmoke',
        boxShadow: sliderBoxShadow,
        marginTop: -5,
        marginLeft: -10,
        '&:focus, &:hover, &$active': {
            boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: sliderBoxShadow,
            },
        },
    },

    active: {},

    valueLabel: {
        left: 'calc(-50% +10px)',
        top: -22,

        '& *': {
            background: '#F1EC40',
            color: '#555555',
            padding: '0px',
        },
        fontFamily: "'Montserrat', sans-serif",
        fontSize: "12px",
        fontWeight: "normal"

    },

    track: {
        width: "12px !important",
        opacity: 0.6,
        backgroundColor: '#faf543',
        borderRadius: 10,
        boxShadow: "inset 5px 5px 10px #b4b030, inset -5px -5px 10px #ffff56",

    },

    trackFalse: {
        opacity: 0.5,
    },

    rail: {
        width: "12px !important",
        opacity: 1.0,
        backgroundColor: '#949494',
        borderRadius: 10,
        boxShadow: "inset 5px 5px 10px #6b6b6b, inset -5px -5px 10px #bdbdbd",
    },

    mark: {
        backgroundColor: 'transparent',
        //height: 15,
        //width: 1,
        //marginTop: -5,
    },

    markLabel: {
        marginLeft: 15,
        marginBottom: 0,
        fontFamily: "'Montserrat', sans-serif ",
        fontSize: '12px',
    },


    markActive: {
        opacity: 1,
        backgroundColor: 'transparent',
    },

}))(Slider);

const styleSliderLabel = {
    color: "#555555",
    fontSize: "14px",
    fontFamily: "'Montserrat', sans-serif ",
    marginTop: '20px',

};


export default function CustomizedSlider(props) {
    const classes = useStyles();

    return (
        <div>
            <Typography 
                id="vertical-slider"
                align="center"
                style={styleSliderLabel}>
                {props.labelOfSlider}
                <br />
                {props.labelOfSliderUnit}
            </Typography>
        <div className={classes.root}>

            <VerticalSlider
                aria-labelledby="vertical-slider"
                valueLabelFormat={valueLabelFormat}
                value={props.value}
                max={props.max}
                min={props.min}
                step={props.step}
                orientation={'vertical'}
                marks={[
                    //{
                    //    value: props.min,
                    //    label: props.min
                    //},
                    //{
                    //    value: props.second,
                    //    label: props.second
                    //},
                    //{
                    //    value: props.third,
                    //    label: props.third
                    //},
                    //{
                    //    value: props.fourth,
                    //    label: props.fourth
                    //},
                    //{
                    //    value: props.max,
                    //    label: props.max
                    //}
                ]}
                valueLabelDisplay={props.valueLabelDisplay}
                onChange={props.onChange}
                disabled={props.disabled}
                track={props.track} />
            <div className={classes.margin} />
            </div>
        </div>
    );
}
